

const padZero = (num) => {
    return num < 10 ? '0' + num : num.toString();
}


/**
 * Decimal to HH:MM
 * @param {*} value
 * @returns
 */
export const formatDecimalToTimeHHMM = (value) => {

    if (!value) {
        return '00:00';
    }

    const tempoDecimal = value;
    const horas = Math.floor(tempoDecimal);
    const minutos = Math.round((tempoDecimal - horas) * 60);
    return `${padZero(horas)}:${padZero(minutos)}`;

};



/**
 * HH:MM to Decimal
 * @param {*} value
 * @returns
 */
export const formatTimeHHMMToDecimal = (hhmm) => {


    if (!hhmm) {
        return 0;
    }

    if (typeof hhmm !== 'string') {
        return hhmm;
    }

    const [horasStr, minutosStr] = hhmm.split(':');
    const horas = parseInt(horasStr);
    const minutos = parseInt(minutosStr);
    return horas + minutos / 60;
};